// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bFCq","title":"styles_title__13t_s"};